/* add-to-cart-form.js
   Helpers de UI do quick-add e seleção de variante em product-card.

   Refatorado em 14/mai/2026:
   - Event delegation no document ($.on) ao invés de registrar listener
     em cada elemento que existia no momento da inicialização.
   - Removidos os 4× reInitTriggerClick (ready + 3 setTimeouts em 5/10/15s)
     que acumulavam handlers sem cleanup — agora 1 listener cobre todos
     os elementos, presentes e futuros (Section Rendering, lazy load, etc).
   - Update hardcoded de .sub-price/.ot-price (data-price-sub = 20% off fixo)
     foi desabilitado em 13/mai/2026; loop-mini.js cuida desses preços.
*/

Shopify.formatMoney = function(cents, format) {
  if (typeof cents == 'string') {
    cents = cents.replace('.', '');
  }
  var value = '';
  var placeholderRegex = /{{\s*(\w+)\s*}}/;
  var formatString = (format || this.money_format);
  function defaultOption(opt, def) {
    return (typeof opt == 'undefined' ? def : opt);
  }
  function formatWithDelimiters(number, precision, thousands, decimal) {
    precision = defaultOption(precision, 2);
    thousands = defaultOption(thousands, ',');
    decimal = defaultOption(decimal, '.');
    if (isNaN(number) || number == null) {
      return 0;
    }
    number = (number / 100.0).toFixed(precision);
    var parts = number.split('.'),
      dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands),
      cents = parts[1] ? (decimal + parts[1]) : '';
    return dollars + cents;
  }
  switch (formatString.match(placeholderRegex)[1]) {
    case 'amount':
      value = formatWithDelimiters(cents, 2);
      break;
    case 'amount_no_decimals':
      value = formatWithDelimiters(cents, 0);
      break;
    case 'amount_with_comma_separator':
      value = formatWithDelimiters(cents, 2, '.', ',');
      break;
    case 'amount_no_decimals_with_comma_separator':
      value = formatWithDelimiters(cents, 0, '.', ',');
      break;
  }
  return formatString.replace(placeholderRegex, value);
};

// [removed] Recharge-specific listeners for `.rc-widget` / `.rc-ot-price` / `.rc-sub-price`
// Recharge was uninstalled; Loop Subscriptions handles selling plans natively.

$(document).ready(function () {
  // ---- Event delegation: 1 listener no document cobre elementos presentes e futuros ----

  // Quick-view: clica no card e abre quick-add panel (botão comentado no product-card hoje, mantido por compat)
  $(document).on('click', '.quick-view-trigger', function () {
    $(this).closest('.card--product').find('.js-quick-add').trigger('click');
  });

  // Abre painel atc-options
  $(document).on('click', '.atc-options', function () {
    $(this).closest('.card--product').find('.atc-options-wrapper').addClass('open');
  });

  // Fecha painel atc-options
  $(document).on('click', '.close_quick', function () {
    $(this).closest('.card--product').find('.atc-options-wrapper').removeClass('open');
  });

  // Toggle entre One-Time / Subscribe — sincroniza name do <select> de selling plan
  $(document).on('click', '.purchase_option', function () {
    var valueOption = $(this).data('option');
    if (valueOption === 'sub') {
      $(this).closest('.wrap-subscription').find('.selling_plan_product').attr('name', 'selling_plan');
    } else {
      $(this).closest('.wrap-subscription').find('.selling_plan_product').attr('name', '');
    }
  });

  // Clique em chip de variante: sincroniza input[name="id"] do form.
  // Nota: variant-picker.js (web component do tema) também sincroniza isso via updateVariantInput().
  // Esta linha é redundante mas mantida como fallback compat com markup customizado de card.
  // Os setters de .ot-price e .sub-price foram REMOVIDOS em 13/mai/2026 (loop-mini.js cuida).
  $(document).on('click', '.option-selector label.opt-label--btn', function () {
    var product_id = this.getAttribute('data-product-id');
    var input = this.querySelector('input');
    if (!product_id || !input) return;
    var variant_id = input.value;
    $('form#product-form-' + product_id).find('[name="id"]').val(variant_id);
  });
});
